import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Layout from "./components/Layout";
import References from "./pages/References";
import Contact from "./pages/Contact";
import Offers from "./pages/Offers";
import About from "./pages/About";
import Projects from "./pages/Projects";

const RedirectToHome = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/');
  }, [navigate]);

  return null;
}

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="*" element={<Layout><RedirectToHome /></Layout>} />
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/about-us" element={<Layout><About /></Layout>} />
      <Route path="/offer" element={<Layout><Offers /></Layout>} />
      <Route path="/references" element={<Layout><References /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/our-projects" element={<Layout><Projects /></Layout>} />
    </Routes>
  );
}
export default App;
